import { render, staticRenderFns } from "./view-voucher-cards.vue?vue&type=template&id=a68afd64&"
import script from "./view-voucher-cards.vue?vue&type=script&lang=js&"
export * from "./view-voucher-cards.vue?vue&type=script&lang=js&"
import style0 from "./view-voucher-cards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue/rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports